import React from 'react'
import { UploadCloud } from 'react-feather'

import { LoadingBar } from '@frame/ui-components/loading-bar'

import { Header } from '../header'

type Props = {
  fileName: string
  isLoading: boolean
}

export function Processing({ fileName, isLoading }: Props) {
  const setSelectedFileNoop = () => void {}

  return (
    <>
      <Header Icon={UploadCloud} name={fileName} setSelectedFileToRemove={setSelectedFileNoop} />
      <LoadingBar isLoading={isLoading} />
    </>
  )
}
